<template>
    <DCard
        padding
    >
        <DAlert
            v-if="message !== null"
            :color="'success'"
            class="m-2 p-3"
        >
            {{ message }}
        </DAlert>
        <Form
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>

    <TenantCreationModal
        v-if="showCreationModal"
        :show-modal="showCreationModal"
        :internal-support-link="internalSupportLink"
        @close-modal="showCreationModal = false"
        @creation-done="creationDone"
        @creation-failed="creationFailed"
    />
</template>

<script>
import Form from '~@/Components/Tools/Testing/Tenants/Form'
import TenantCreationModal from '~@/Components/Tools/Testing/Tenants/TenantCreationModal'

export default {
    name: 'TenantsCreate',
    components: {
        TenantCreationModal,
        Form
    },
    props: {
        internalSupportLink: {
            type: String,
            default: () => { return '' }
        }
    },
    data () {
        return {
            showCreationModal: false,
            errors: {
                copy_from_tenant: [''],
                name: ['']
            },
            message: null
        }
    },
    methods: {
        submitData (form) {
            this.resetErrors()
            this.showCreationModal = true
            window.axios
                .post(this.$route('tools.tenant.store'), {
                    name: form.name
                })
                .catch((error) => {
                    if (error && error.response && error.response.data) {
                        this.errors = error.response.data.errors
                        this.showCreationModal = false
                    }
                })
        },
        async creationDone (newTenant) {
            this.showCreationModal = false
            this.message = 'Tenant ' + newTenant + ' was created'
        },
        async creationFailed (error) {
            this.showCreationModal = false
            this.$page.props.messages = error
        },
        resetErrors () {
            this.errors = {
                name: ['']
            }
        }
    }
}
</script>
